import Clinic from 'src/models/clinic';

export const normalizeAddress = (address: string) => {
  if (!address) {
    return '';
  }

  let normalized = address.toLowerCase();

  // remove punctuation that may separate unit numbers
  normalized = normalized.replace(/[.,-]/g, ' ');
  normalized = normalized.replace(/#/g, ' ');

  const replacements: Record<string, string> = {
    // Directions
    'north': 'n',
    'south': 's',
    'east': 'e',
    'west': 'w',
    'n.': 'n',
    's.': 's',
    'e.': 'e',
    'w.': 'w',

    // Street types
    'street': 'st',
    'st.': 'st',
    'avenue': 'ave',
    'ave.': 'ave',
    'boulevard': 'blvd',
    'road': 'rd',
    'drive': 'dr',
    'lane': 'ln',
    'court': 'ct',
    'place': 'pl',
    'parkway': 'pkwy',
    'highway': 'hwy',
    'circle': 'cir',
    'terrace': 'ter',
    'trail': 'trl',

    // Unit types (remove them completely)
    'suite': '',
    'ste': '',
    'ste.': '',
    'apartment': '',
    'apt': '',
    'unit': '',
    'floor': '',
    'fl': ''
  };

  const escapeRegex = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  Object.entries(replacements).forEach(([key, value]) => {
    const regex = new RegExp(`\\b${escapeRegex(key)}\\b`, 'g');
    normalized = normalized.replace(regex, value);
  });

  // collapse spaces
  normalized = normalized.replace(/\s+/g, ' ').trim();

  return normalized;
};

export const getClinicAddressKey = (clinic: Clinic): string => {
    const address = normalizeAddress(clinic.addressLine1);
    const city = (clinic.city || '').toLowerCase().trim();
    const state = (clinic.state || '').toLowerCase().trim();
    const zip = (clinic.zipCode || '').split('-')[0].trim();

    return `${address}|${city}|${state}|${zip}`;
};

export const getDuplicateClinicIds = (clinics: Clinic[]): Set<string> => {
    const map = new Map<string, string[]>();

    clinics.forEach(c => {
        const key = getClinicAddressKey(c);

        if (!key.trim()) {
            return;
        }
        if (!map.has(key)) {
            map.set(key, []);
        }

        map.get(key)!.push(c.id);
    });

    const duplicates = new Set<string>();

    map.forEach(ids => {
        if (ids.length > 1) {
            ids.forEach(id => duplicates.add(id));
        }
    });

    return duplicates;
};


// WEBPACK FOOTER //
// ./src/utils/addressUtility.ts